import { GetAbsenceApi } from '../api';
import { toast } from 'react-toastify';
import { GetToDay, StartCurrentMonth } from "../utils";

export const handelGetListAbsencesMethod = async (
    startDate:any ,
    endDate:any ,
    setAbsences: (list: any) => void,
    setDisplaySkeleton: (bol: boolean) => void,
    pagination: any,
    setPagination: (obj: any) => void,

) => {
    let start = StartCurrentMonth()
    let end = GetToDay()
    if(startDate && endDate){
        start = startDate ;
        end = endDate
    }
    try {
        setDisplaySkeleton(true)
        let res = await GetAbsenceApi(start , end ,  pagination?.current)
        setDisplaySkeleton(false)
        if (res.data.success) {
            setAbsences(res.data.data)
        }
        else {
            toast(res.data.message, { type: "error" })
            setDisplaySkeleton(false)
            setPagination({
                'current': res.data.data.logs.current_page,
                'total': res.data.data.logs.last_page	,
            })
        }
    }
    catch (err: any) {
        setDisplaySkeleton(false)
    }
}
